import React from "react";

const Mission = () => {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10 sm:py-18 lg:py-18">
      <div className="text-center mb-10 sm:mb-20 lg:mb-20">
        {/* Quote mark */}
        <div className="text-6xl sm:text-7xl lg:text-8xl font-thin text-gray-800 mb-6 sm:mb-8">
          "
        </div>

        {/* Main quote */}
        <blockquote className="text-md sm:text-lg md:text-xl lg:text-2xl font-light leading-relaxed max-w-3xl mx-auto tracking-wide text-gray-200">
          AI is reshaping how professionals excel and how organizations operate, compete, and grow.
          <br className="hidden sm:block" />
          <em className="text-gray-400">
            Our mission is to ensure you are not merely adapting but leading.
          </em>
        </blockquote>
      </div>
    </div>
  );
};

export default Mission;
